import type { ResourceScopeParams } from "@/lib/resource-context";

export const onboardingKeys = {
  /**
   * Matches every onboarding query for the current user across all
   * orgs/projects. Use for account-scoped invalidations (dismiss, tool
   * execution) whose underlying state is not per-project.
   */
  all: () => ["onboarding"] as const,
  /** Matches all onboarding queries for one project. */
  project: ({ scope }: ResourceScopeParams) =>
    [...onboardingKeys.all(), scope.organizationId, scope.projectId] as const,
  progress: (params: ResourceScopeParams) =>
    [...onboardingKeys.project(params), "progress"] as const,
  eligibility: (params: ResourceScopeParams) =>
    [...onboardingKeys.project(params), "eligibility"] as const,
};
